export function TwitterIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>T w i t t e r</title>
      <path
        d="M13.94 10.392L21.54 1.5H19.74L13.14 9.22L7.87 1.5H1.8L9.76 13.176L1.8 22.5H3.6L10.56 14.346L16.13 22.5H22.2L13.94 10.392ZM11.48 13.278L10.67 12.12L4.25 2.865H7.01L12.19 10.33L13 11.493L19.74 21.198H16.97L11.48 13.278Z"
        fill="currentColor"
      />
    </svg>
  );
}
